export enum SecurityScope {
  BuiltIn = 'BuiltIn',
  AdminDomain = 'AdminDomain',
  Organization = 'Organization',
}
